import React, { useState } from 'react';
import UI from "components/UI";
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import StringUtil from 'utils/StringUtil';
import UICheckbox from 'components/checkbox/UICheckbox';
import UIRadio from 'components/radios/UIRadio';
import TbCommBiz from 'domain/main/comm/biz/TbCommBiz';
import UIUtils from "utils/UIUtils";
import message from "common/message/source/MessageSource";
import userStore from "common/user/store/UserStore";
import AuthorSelected from "./AuthorSelected";                      //권한목록
import BusinessManagerSelected from "./BusinessManagerSelected";    //사업목록
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
//import PageLoading from "../../../../components/loading";


function ContentsContainer(props: any) {
	const location = useLocation();
	const [memberInfo, setMemberInfo] = useState({});
  	const receivedData = (location.state as any)?.data;
	const history = useHistory();
	let authorSelectedList: AuthorSelected[] = [];
	let businessManagerAllList:BusinessManagerSelected[] = [];
	const [businessManagerSelectedList, setBusinessManagerAllList] = React.useState<any[]>([]);

	const [loadFinish,setLoadFinish] = useState(false);
	let tbSysUserAuthorList:any[] = [];
	let tbSysAuthorList:any[] = [];
	const [userRoleList, setuserRoleList] = React.useState<any[]>([]);
	const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);  //파일업로드 

	const modaladm4111 = useToggleState({});
	const modaladm4112 = useToggleState({});
	const [userId,setUserId] = useState('')
	
	const [loginFailCnt,setLoginFailCnt] = useState(0) //비밀번호 오류횟수 

	//목록에서 넘어온 파라미터 정의
	const [userTpCd,setUserTpCd] = useState('');
	const [useYn,setUseYn] = useState('');
	const [loginNm,setLoginNm] = useState('');   
	const [personId,setPersonId] = useState('');
	const [personNm,setPersonNm] = useState('');
	const [creatDt ,setCreatDt] = useState('');
	const [apprDate ,setApprDate] = useState('');
	const [apprYn ,setApprYn] = useState('');
	const [apprYnNm ,setApprYnNm] = useState('');
	const [bizNo ,setBizNo] = useState('');
	const [corpNm ,setCorpNm] = useState('');
	const [deptNm ,setDeptNm] = useState('');
	const [emailAdres ,setEmailAdres] = useState('');
	const [emailApprYn ,setEmailApprYn] = useState('');
	const [hpNo ,sethpNo] = useState('');
	const [ofcTelNo ,setOfcTelNo] = useState('');
	const [posiNm ,setPosiNm] = useState('');
	const [userTpCdNm ,setUserTpCdNm] = useState('');
	const [writngDt ,setWritngDt] = useState('');
	const [emailApprDate ,setEmailApprDate] = useState('');
	const [emailApprKey ,setEmailApprKey] = useState('');
	const [loginPassword ,setLoginPassword] = useState('');
	const [confirmPassword ,setConfirmPassword] = useState('');
	const [regNm ,setRegNm] = useState('');
	
	
	//파일정보 선언 
	let [signFileValue] = useState(new TbComFile());
	const [fileValue, setFileValue] = useState(new TbComFile());

	// 폼체크 여부 
	const [formCheck,setFormCheck] = useState(false);  


	// 상세 데이터 가져오기
	async function initCall(paramPersonId){
		let param = {
			"PERSON_ID": paramPersonId
		};

		const response:any = await CommonUtil.execute({
			url:'adm_4110_detail',
			data: param,
			progressBar:true
		}).then()

		const result = response;
        if(response !=null){
			//데이터 바인딩
			setMemberInfo(result);

			setUserTpCd(result.USER_TP_CD);
			setLoginNm(result.LOGIN_NM)
			setPersonNm(result.PERSON_NM);
			setDeptNm(result.DEPT_NM);
			setPosiNm(result.POSI_NM);
			setBizNo(result.BIZ_NO);
			setCorpNm(result.CORP_NM);
			//sethpNo(result.HP_NO);
			setEmailAdres(result.EMAIL_ADRES);
			//setOfcTelNo(result.OFC_TEL_NO);
			setUseYn(result.USE_YN);
			setUserId(result.USER_ID);
			setApprDate(result.APPR_DATE);
			setApprYn(result.APPR_YN);
			sethpNo(StringUtil.phoneFomatter(result.HP_NO, 1));
			setOfcTelNo(StringUtil.phoneFomatter(result.OFC_TEL_NO, 1));
			setEmailApprYn(result.EMAIL_APPR_YN);
            setRegNm(result.REG_PERSON_ID);
			 

			//비밀번호 오류횟수 가져오기
			userLoginFailrAction("select" , result.LOGIN_NM);

			let fileInfoList = result.FILE_INFO_LIST;

			//console.log("adm_4110_detail :: "+JSON.stringify(response));
			
			
			  //파일정보 있을경우
			//@ts-ignore
			if(fileInfoList!= null){
				const tempFileValue = new TbComFile();
				fileInfoList?.forEach((item, index) => {
					const fileDetail = new TbComFileMapngDetail();
					fileDetail.setDwldId(item.DWLD_ID);
					fileDetail.setFileDetailId(item.FILE_DETAIL_ID);
					fileDetail.setFilePolicy(item.FILE_POLICY);
					fileDetail.setFileRpstr(item.FILE_RPSTR);
					fileDetail.setStrePath(item.STRE_PATH);
					fileDetail.setStreFileNm(item.STRE_FILE_NM);
					fileDetail.setOrginlFileNm(item.ORGINL_FILE_NM);
					fileDetail.setFileExtsn(item.FILE_EXTSN);
					fileDetail.setFileSize(Number(item.FILE_SIZE));
					fileDetail.setRegistDt(item.REGIST_DT);
					fileDetail.setRegistPsnNm(item.REGIST_PSN_NM);

					tempFileValue.putTbComFileMapngDetailList(fileDetail);
				})
				setFileValue(tempFileValue);
			}
			
			setLoadFinish(true);
		}

	};

	//상세정보 값 가지고 오기
	function getInfo(name){
		if(Object.keys(memberInfo).length != 0){
			return memberInfo[name];
		}else{
			return '';
		}
	};

    //====== 유저 로그인 실패횟수 액션 START
	async function userLoginFailrAction(sAction:string, pLoginNm:string) {
		//파라미터 
		let param = {
			"LOGIN_NM": pLoginNm
		};

		//5회 오류 해제시 사용액션
		if(sAction =="updateZero"){
			if (await UIUtils.confirm("비밀번호오류횟수를 초기화 하시겠습니까?")) {
				// 전송
				const response:any = await CommonUtil.execute({
					url:"adm_4110_TbSysUserLoginFailr_updateZero",
					data: param
				})

				if (response != null) {
					UIUtils.alert('로그인횟수가 초기화 되었습니다.').then();
					//비밀번호 오류횟수 초기화
					setLoginFailCnt(0);     //초기화 0
					//window.location.reload();
				}
			}
		}else if (sAction == "select") { 
			// 전송
			const response:any = await CommonUtil.execute({
				url:"adm_4110_TbSysUserLoginFailr_select",
				data: param
			})
			//비밀번호 오류횟수
			//console.log(' FAILR_CO : '+ response.FAILR_CO);  
			setLoginFailCnt(response.FAILR_CO); //비밀번호 오류횟수 저장
			
		}

		
    }
//====== 유저 로그인 실패횟수 액션 END


//====== 유저 권한 액션 START
  /**
   * 권한 조회
   */
  async function userAuthorAction() {
	//파라미터 
	let param = {
		"PERSON_ID": personId
	};

	/*personId 로 userId를 조회 해서 아래 2항목을 가지와야한다.
	 1. selectListByPersonId  TCPU.USER_ID 가지고온다
	 2. TbComPersonEntityMapper.select
	3. selectByUserId 
	 4. selectSortOrdrUserYnListUserYn
	*/
	
	const response:any = await CommonUtil.execute({
		url:"TbComPersonUserEntityMapper_selectListByPersonId",
		data: {"PERSON_ID": personId}
	})

    if(response.REC[0].USER_ID !=""){
		setUserId(response.REC[0].USER_ID);

		const userRoleList:any = await CommonUtil.execute({
			url:"TbSysUserAuthorMapper_selectByUserId",
			data: {"USER_ID": response.REC[0].USER_ID}
		})

		tbSysUserAuthorList = userRoleList.REC;
	}


	const roleList:any = await CommonUtil.execute({
		url:"TbSysAuthorMapper_selectSortOrdrUserYnListUserYn",
		data: {}
	})
	
	//권한 목록
	tbSysAuthorList = roleList.REC;
	
	for (const tbSysAuthor of tbSysAuthorList) {
		let authorSelected: AuthorSelected = new AuthorSelected;
		authorSelected.setAuthorId(tbSysAuthor.AUTHOR_ID);
		authorSelected.setAuthorNm(tbSysAuthor.AUTHOR_NM);
		authorSelected.setUserid(response.REC[0].USER_ID);
		authorSelected.setSelectYn(false); // 기본값은 false로 설정

		for (const tbSysUserAuthor of tbSysUserAuthorList) {
			
			if (authorSelected.getAuthorId() === tbSysUserAuthor.AUTHOR_ID) {
				authorSelected.setSelectYn(true);
				break;
			}
		}

		authorSelectedList.push(authorSelected);
	}

	setuserRoleList(authorSelectedList);
	if(authorSelectedList != null){

		modaladm4111.open();
	}
	
}

/**
   * 권한 수정  
   * 1. 기존 권한 delete
   * 2. 새로운 권한 insert
   */
async function updateAuthorList() {
    let result;
    //지정 사업 리스트 갯수 확인
    let checkEmptyList: boolean = true;

    // eslint-disable-next-line array-callback-return
     userRoleList.map((authorSelected: AuthorSelected) => {
	 	//console.log('authorSelected.isSelectYn() :'+ authorSelected.getAuthorNm() + "/ "+authorSelected.isSelectYn())
       if (authorSelected.isSelectYn() === true) {
		
         checkEmptyList = false;
       }
     });
    if (checkEmptyList) {
		UIUtils.alert("권한을 지정해주세요.").then();
      return;
    }

    if (await UIUtils.confirm("권한을 지정하시겠습니까?")) {
    
		// 지정한 사용자 권한 삭제
		const response:any = await CommonUtil.execute({
			url:"TbSysUserAuthorEntityMapper_deleteListByUserId",
			data: {"USER_ID": userId}
			
		})

		//지정한 role로 입력
		for (const authorSelected of userRoleList) {
			if (authorSelected.selectYn === true) {	  

				//userId 는 로그인한 사용자의 userId가지고 와야한다.
				//console.log("authorId : "+authorSelected.authorId + "userId : "+userId);
				// 전송
				const insertUserRole:any = await CommonUtil.execute({
					url:"TbSysUserAuthorEntityMapper_insert",
					data: {"AUTHOR_ID": authorSelected.authorId , "USER_ID":userId , "CREAT_USER_ID":userId}
				})
			}
		}
		modaladm4111.close();
		UIUtils.alert(message.get("common.message.save.success", "저장되었습니다.")).then();
	}

		
		
  }

  /**
   * 지정사업 조회
   *
   * @param personId
   */
  async function getAllBizManagerList(){
    // 지정사업 조회 
	const response:any = await CommonUtil.execute({
		url:"TbCommBizMapper_selectAllBizList",
		data: ''
   	})

	   let result = response.REC;
	   for (let i=0;i<result.length; i++) {
			//console.log( " result [0] : "+ result[i].BIZ_CD +" / " + result[i].BIZ_NM + " / " + result[i].BIZ_SHORT_NM );
			
			let businessManagerSelected: BusinessManagerSelected = new BusinessManagerSelected;
			businessManagerSelected.setBizCd(result[i].BIZ_CD);
			businessManagerSelected.setBizNm(result[i].BIZ_NM);
			businessManagerSelected.setBizShortNm(result[i].BIZ_SHORT_NM);
			businessManagerAllList.push(businessManagerSelected);
	   }
	   
	   setBusinessManagerAllList(businessManagerAllList);

	   //console.log(" businessManagerAllSelectedList  : "+JSON.stringify(businessManagerAllList));
  }


  /**
   * 사용자별 지정사업 조회
   *
   * @param personId
   */
  async function getBizManager(personId: string){
    
	//사용자별 사업지정 목록
	const response:any = await CommonUtil.execute({
		url:"TbCommMangBizCdMapper_selectByUserId",
		data: {"PERSON_ID": personId}
	})

    let userBizSelList = response.REC;
	let addBusinessManagerAllList:BusinessManagerSelected[] = [];
	for (const businessManagerAll of businessManagerSelectedList) {    //전체 사업목록
		for (let i = 0; i<userBizSelList.length; i++) {    //사용자의 자정된 사업목록	
			if (businessManagerAll.getBizCd() == userBizSelList[i].BIZ_CD) {
				businessManagerAll.setSelectYn(true);
				businessManagerAll.setUserid(userBizSelList[i].USERID);
				if(userBizSelList[i].BASE_BIZ_YN == "Y") {
					businessManagerAll.setBaseBizYn(true);
				}else{
				    businessManagerAll.setBaseBizYn(false);
				}
			}
		}

		addBusinessManagerAllList.push(businessManagerAll);
	}
	
	setBusinessManagerAllList(addBusinessManagerAllList);
	
	if(businessManagerSelectedList !=null){
		modaladm4112.open();
	}
  }

   //사업지정 기본 선택
   function changedRadios(targetIndex?) {
    businessManagerSelectedList.forEach((businessManagerSelected: BusinessManagerSelected, index) => {
      if (targetIndex == null || targetIndex !== index) {
        businessManagerSelected.setBaseBizYn(false);
      }
    });
  }

   /**
   * 사업 지정 수정
   *
   * @param businessManagerSelectedList
   */
   async function putBizManager() {
    
	 //지정 사업 리스트 갯수 확인
	 let checkEmptyList: boolean = true;
	 let checkEmptyBaseYn: boolean = true;
	 // eslint-disable-next-line array-callback-return
	 businessManagerSelectedList.map((businessManagerSelected: BusinessManagerSelected) => {
	   businessManagerSelected.setUserid(personId);
	   if (businessManagerSelected.isSelectYn() === true) {
		 checkEmptyList = false;
	   }
	   if (businessManagerSelected.isBaseBizYn() === true) {
		 checkEmptyBaseYn = false;
	   }
	 });
	 if (checkEmptyList) {
	   UIUtils.alert("사업을 지정해주세요.").then();
	   return;
	 }
	 if (checkEmptyBaseYn) {
		UIUtils.alert("기본 사업을 지정해주세요.").then();
	   return;
	 }
	 if (await UIUtils.confirm("사업을 지정하시겠습니까?")) {
	 
		businessManagerSelectedList.map((businessManagerSelected: BusinessManagerSelected) => businessManagerSelected.setUserid(personId));

		// 지정한 사업 삭제
		const deleteUserBiz:any = await CommonUtil.execute({
			url:"TbCommMangBizCdMapper_deleteByPersonId",
			data: {"USER_ID": businessManagerSelectedList[0].getUserid()}
		
		})
	
		//지정한 사업으로 입력
		for (const businessManagerSelected of businessManagerSelectedList) {
			//체크값이 true 만 전송
			if (businessManagerSelected.selectYn === true) {	  
				// 전송
					const inserUserBiz:any = await CommonUtil.execute({
						url:"TbCommMangBizCdEntityMapper_insert",
						data: { 
								"BIZ_CD": businessManagerSelected.getBizCd() ,
								"BASE_BIZ_YN":businessManagerSelected.isBaseBizYn() === true?"Y":"N",
								"USER_ID":businessManagerSelectedList[0].getUserid(),
								"PERSON_ID":personId
							}
					})
			}
		}
	
	
		UIUtils.alert(message.get("common.message.save.success", "저장되었습니다.")).then();
		modaladm4112.close();

	}
  }

  
   // 비밀번호 임시발급
   async function createPw() {
    if(await UIUtils.confirm('임시 비밀번호를 발급하시겠습니까?')){
		// const tbSysUser = JSON.stringify(userStore.userModel?.getTbSysUser());
		// const jsonobj = JSON.parse(tbSysUser);
		// let pUserId = jsonobj.userId;
		let params = {
			"LOGIN_NM": loginNm 
			,"USER_LOCALE" : "ko_KR"
		}

		const response:any = await CommonUtil.execute({
			url:"updateNewPassword",
			data: params
		})

		if (!response.COMMON_HEAD.ERROR) {
			UIUtils.alert("임시 비밀번호가 성공적으로 발급되었습니다.").then();
		}
	}
  }
  
   //수정 페이지로 이동
	const pageUpdate = function (){
		
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
		pathname: './adm4114',
		state: { data: receivedData }
	   });
	}


	//이메일 인증 재발송
	async function resendEmail (){
		let params = {
			"LOGIN_NM": loginNm 
			,"PERSON_ID" : personId
		}

		const response:any = await CommonUtil.execute({
			url:"resendEmail",
			data: params
		})

		if (!response.COMMON_HEAD.ERROR) {
			if(response.ERR_CD == "0000"){
				UIUtils.alert("이메일이 성공적으로 발송되었습니다.").then();
			}else{
				UIUtils.alert(response.ERR_MSG).then();
			}
		}
	
	}

	//목록으로 
	const goList = (e) =>{
		history.push({
			pathname: './adm4100',  
			state: { data: receivedData }
		});
	}


    //상세페이지 로딩시 해야할 것
	//비밀번호 오류횟수 , 권한등록 ,사업지정 , 출엽기업 승인, 이메일 인증발송
	React.useEffect(() => {

		if(receivedData != undefined){
			let vPersonId = StringUtil.defaultString(receivedData.vPERSON_ID);
			setPersonId(vPersonId)
			localStorage.setItem("personId", vPersonId);
			//상세데이터 가지고 오기
			initCall(vPersonId);
		}
		
		let personIdStorage = localStorage.getItem("personId");
		if (personIdStorage != null) {
			setPersonId(personIdStorage);
		}
		//비밀번호 오류횟수 가져오기
		//userLoginFailrAction("select" , loginNm);
		//전체 사업목록 가져오기
		getAllBizManagerList();
		
    },[])


	// if(!loadFinish)
	// 	return (
	// 		<PageLoading />
	// 	)
	// else

	return (
		<PageContainer>
			<LayoutAside />
			<div className="fww-con">
				<ul className="fww-brd">
					<li><Link to="/admin">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">사용자관리</Link></li>
					<li><Link to="#">회원관리</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">회원정보 상세</h1>
					<div className="fo fo-col3 mb10">
						<div className="inner">
							<div className="fo-item">
								<p className="fo-key">사용자유형</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={StringUtil.defaultString(getInfo("USER_TP_CD_NM"))} readOnly={true}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">사용자ID</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={StringUtil.defaultString(getInfo("LOGIN_NM"))} readOnly={true}/>
								</div>						
							</div>
							<div className="fo-item">
								<p className="fo-key">사용자명</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={StringUtil.defaultString(getInfo("PERSON_NM"))} readOnly={true}/>
								</div>						
							</div>
							<div className="fo-item">
								<p className="fo-key">기업명</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={getInfo("CORP_NM")} readOnly={true}/>
								</div>						
							</div>
							<div className="fo-item">
								<p className="fo-key">부서</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={StringUtil.defaultString(getInfo("DEPT_NM"))} readOnly={true}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">담당업무</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={StringUtil.defaultString(getInfo("PERSON_TASK"))} readOnly={true}/>
								</div>						
							</div>
							<div className="fo-item">
								<p className="fo-key">직급</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={StringUtil.defaultString(getInfo("POSI_NM"))} readOnly={true}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">휴대폰번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={StringUtil.defaultString(hpNo)} valueChanged={(value) => sethpNo(value)}  readOnly={true}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">이메일</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={StringUtil.defaultString(getInfo("EMAIL_ADRES"))} readOnly={true}/>
								</div>						
							</div>
							<div className="fo-item">
								<p className="fo-key">사무실전화번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={StringUtil.defaultString(ofcTelNo)} valueChanged={(value) => setOfcTelNo(value)} readOnly={true}/>
								</div>						
							</div>
							<div className="fo-item">
								<p className="fo-key">이메일 인증</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={getInfo("EMAIL_APPR_YN") == "1"?"예":"아니오"} readOnly={true}/>
								</div>						
							</div>
							<div className="fo-item">
								<p className="fo-key">인증일시</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={StringUtil.defaultString(getInfo("EMAIL_APPR_DATE"))} readOnly={true}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">비밀번호오류횟수</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={loginFailCnt==null?"0":loginFailCnt} readOnly={true}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">승인일자</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={StringUtil.defaultString(getInfo("APPR_DATE"))} readOnly={true}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">승인여부</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={StringUtil.defaultString(getInfo("APPR_YN_NM"))} readOnly={true}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">사용여부</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={StringUtil.defaultString(getInfo("USE_YN_NM"))} readOnly={true}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">등록자</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={StringUtil.defaultString(regNm)} readOnly={true}/>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">등록일시</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={StringUtil.defaultString(getInfo("WRITNG_DT"))} readOnly={true}/>
								</div>
							</div>	
							<div className="fo-item"></div>
													
						</div> 
						<div className="fo-item fo-m-1-3">
								<p className="fo-key">싸인이미지</p>
								<div className="fo-value ">
								<UI.FileDownload
									value={fileValue}
									className={"w100p"}
									attrs={{ImgPreView: "1",Views: "thumbs"}}
                            		/>
								</div>
							</div>	
					</div>						
					<div className="hz-root hz-right hz-gap5">
						<UI.If test={userTpCd != 'N'}>
							<Button color='gray-o' size="sm" onClick={(e) => userLoginFailrAction('updateZero' ,loginNm)}>비밀번호 오류해제</Button>
							<Button color='gray-o' size="sm" onClick={(e)=>userAuthorAction()}>권한등록</Button>
							<Button color='gray-o' size="sm" onClick={(e)=>getBizManager(personId) }>사업지정</Button>
							<Button color='gray-o' size="sm" onClick={(e)=>createPw()}>임시비밀번호발급</Button>
							<Button color='pri-o' size="sm" onClick={(e)=>pageUpdate()} >수정</Button>
						</UI.If>
						<UI.If test={userTpCd == 'N'}>
							<UI.If test={loginFailCnt >= 5}>
								<Button color='gray-o' size="sm" onClick={(e) => userLoginFailrAction('updateZero' ,loginNm)}>비밀번호 오류해제</Button>
							</UI.If>
							<UI.If test={emailApprYn == "0"}>
								<Button color='gray-o' size="sm" onClick={(e)=>resendEmail()}>이메일 인증 재발송</Button>
							</UI.If>
							<Button color='gray-o' size="sm" onClick={(e)=>createPw()}>임시비밀번호발급</Button>
						</UI.If>
						
						<Button color='gray-o' size="sm" onClick={goList}>목록</Button>
					</div>
				</main>
			</div>
			{/* modal - 권한등록 */}
			<ModalPopup
				open={modaladm4111.isShowing}
				title="권한등록"
				size="mid"
				onClose={modaladm4111.close}
			>
				<div className="modal-con">
					<div className="tb">
							<table>
								<caption></caption>
								<colgroup>
									<col width="50px" />
									<col width="50px" />
									<col width="" />
								</colgroup>
								<thead>
									<tr>
										<th>번호</th>
										<th>선택</th>
										<th>권한</th>
									</tr>
								</thead>
								<tbody>
									{userRoleList != null? userRoleList.map((authorSelected: AuthorSelected, index) => (
											<tr key={authorSelected.getAuthorId()}>
											<td className="ta-cetner">{index + 1}</td>
											<td className="ta-cetner">
											<label htmlFor={authorSelected.getAuthorId()} className="hz-item ip-ch-label ip-ch-18">
												<UICheckbox
													value={authorSelected.isSelectYn()}
													valueChanged={(value) => {
														authorSelected.setSelectYn(value);
													}}
												/>
											</label>
											</td>
											<td className="ta-left">{authorSelected.getAuthorNm()}</td>
											</tr>
										))
										: "데이터가 없습니다."}
									</tbody>
							</table>
							
						</div>
				</div>
				<div className="modal-bottom">
					<Button color='pri' size="big" onClick={()=>updateAuthorList()}>권한지정</Button>
				</div>	
			</ModalPopup>
			{/* modal - 사업지정 */}
			<ModalPopup
				open={modaladm4112.isShowing}
				title="사업지정"
				size="mid"
				onClose={modaladm4112.close}
			>
				<div className="modal-con">
						<div className="tb">
							<table>
								<caption></caption>
								<colgroup>
									<col width="50px" />
									<col width="50px" />
									<col width="50px" />
									<col width="" />
								</colgroup>
								<thead>
									<tr>
										<th>번호</th>
										<th>선택</th>
										<th>기본</th>
										<th>사업명</th>
									</tr>
								</thead>
								<tbody>

								{businessManagerSelectedList != null
									? businessManagerSelectedList.map((businessManagerSelected: BusinessManagerSelected, index) => (
										<tr key={businessManagerSelected.getBizCd()}>
										<td className="ta-cetner">{index + 1}</td>
										<td className="ta-cetner">
											<label htmlFor="ch-auth-1" className="hz-item ip-ch-label ip-ch-18">
											<UICheckbox
											value={businessManagerSelected.isSelectYn()}
											valueChanged={(value) => {
												businessManagerSelected.setSelectYn(value);
												if (value === false && businessManagerSelected.isBaseBizYn() === true) {
													changedRadios(null);
												}
											}}
											/>
											</label>
										</td>
										<td className="ta-cetner">
										<label htmlFor="rd-default-1" className="ip-rd-label">
											<UIRadio
											name={"baseBizYn"}
											value={businessManagerSelected.isBaseBizYn()}
											valueChanged={(value) => {
												if (businessManagerSelected.isSelectYn() === true) {
													businessManagerSelected.setBaseBizYn(true);
													changedRadios(index);
												} else {
												UIUtils.alert("선택되지 않은 사업을 기본 사업으로 지정할 수 없습니다.").then();
												}
											}}
											/>
											</label>
										</td>
										<td style={{ textAlign: "center" }}>{businessManagerSelected.getBizShortNm()}</td>
										</tr>
									))
									: "데이터가 없습니다."}									
								</tbody>
								</table>
							
						</div>
				</div>
				<div className="modal-bottom">
					<Button color='pri' size="md" onClick={()=>putBizManager()}>사업지정</Button>
				</div>	
			</ModalPopup>
		</PageContainer>
	);
}
export default ContentsContainer;

